// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"da3261cf","450":"da3261cf","996":"da3261cf"}[chunkId] + ".chunk.css";
};